import ArticleCard from '@components/article-card';
import type { ReactElement } from 'react';
import React from 'react';
import type { PageIndexEntry } from 'types/page-index-entry';
import { validateString } from 'utils/validate-string';

import styles from './page-index-list.module.scss';

export interface PageIndexListProps {
  readonly pageIndexEntries: PageIndexEntry[];
}

const rootClass = validateString(styles.root);
const listClass = validateString(styles.list);

function PageIndexList({ pageIndexEntries }: PageIndexListProps): ReactElement {
  return (
    <div className={rootClass}>
      <ul className={listClass}>
        {pageIndexEntries.map(index => {
          return (
            <ArticleCard
              description={index.description}
              footer={<span>April 2023</span>}
              key={index.title}
              link={index.slug}
              media={index.image}
              title={index.title}
            />
          );
        })}
      </ul>
    </div>
  );
}

export default PageIndexList;
